import { useEffect, useMemo, useState } from 'react';
import { PUBLIC_SERVICE_MENU_ITEMS, type PublicServiceMenuItem } from '@/config/publicServicesMenu';
import { fetchModuleConfig, getDefaultConfig, type ModuleConfig } from '@/config/modules';
import { usePublicCountry } from '@/contexts/PublicCountryContext';

/** Public service links filtered by the selected country's module flags. */
export function usePublicServiceMenuItems(): PublicServiceMenuItem[] {
  const { countryId } = usePublicCountry();
  const [config, setConfig] = useState<ModuleConfig | null>(null);

  useEffect(() => {
    if (!countryId) {
      setConfig(null);
      return;
    }

    let cancelled = false;
    fetchModuleConfig(countryId)
      .then((next) => {
        if (!cancelled) {
          setConfig(next);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setConfig(getDefaultConfig());
        }
      });

    return () => {
      cancelled = true;
    };
  }, [countryId]);

  return useMemo(
    () =>
      PUBLIC_SERVICE_MENU_ITEMS.filter((item) => {
        if (!item.moduleKey) {
          return true;
        }
        if (!countryId) {
          return false;
        }
        return (config || getDefaultConfig())[item.moduleKey];
      }),
    [countryId, config]
  );
}
